'use strict';

class Sidebar {
    constructor() {
        this.sidebar = null;
        this.ticking = false;
    }

    init() {
        this.sidebar = document.getElementById('sidebar');

        if (this.sidebar) {
            this.moveOnScroll();
        }
    }

    moveOnScroll() {
        const self = this;

        window.addEventListener('scroll', function() {
            if (!self.ticking) {
                window.requestAnimationFrame(function() {
                    self.applyScrolledClass(window.scrollY);
                    self.ticking = false;
                });
    
                self.ticking = true;
            }
        });

        self.applyScrolledClass(window.scrollY);
    }

    applyScrolledClass(scrollPosition) {
        const self = this;

        if (scrollPosition > 0) {
            self.sidebar.classList.add('scrolled');
        } else {
            self.sidebar.classList.remove('scrolled');
        }
    }
}